import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

const NewConnection = (props) => { 
    const item = props.item;
    return (
        <li>
            <div className="feed-icon">
                <svg className="icon icn-plug">
                    <use xlinkHref="#icn-plug" />
                </svg>
            </div>
            <Link to={`/${item.RoleUsername}`} className="thumbnail">
                <div className="userthumb">
                    <img src={props.getThumbnail(item.Thumbnail, item.RoleType)} alt="profile picture" />
                </div>
            </Link>
            <p className="type">NEW CONNECTION <span className="time">{item.DateText}</span></p>
            <div className="message">
                <p>
                    New inbound connection to <Link to={`/${item.RoleUsername}`}><strong>{item.RoleDisplayName}</strong></Link>
                </p>
            </div>
        </li>
    );
};

NewConnection.propTypes = {
    item: PropTypes.object.isRequired,
    getThumbnail: PropTypes.func.isRequired
};

export default NewConnection;